export const resetFaqObj = () => {
  return {
    type: 'RESET_FAQ_OBJ',
    payload: {},
  }
}
export const resetFaqStatus = (reset) => {
  return {
    type: 'RESET_FAQ_STATUS',
    payload: reset,
  }
}

export const faqError = (error) => {
  return {
    type: 'FAQ_ERROR',
    payload: error,
  }
}

export const getFaq = (skillId, data) => {
  return {
    type: 'GET_FAQ',
    payload: {
      skillId,
      data,
    }
  }
}
export const setFaq = (skillId, data) => {
  return {
    type: 'SET_FAQ',
    payload: {
      skillId,
      data,
    }
  }
}

export const setActiveSkillId = (skillId) => {
  return {
    type: 'SET_ACTIVE_SKILL_ID_FAQ',
    payload: {skillId},
  }
}

export const updateFaq = (data) => {
  return {
    type: 'UPDATE_FAQ',
    payload: data,
  }
}
export const updatedFaq = (data) => {
  return {
    type: 'UPDATED_FAQ',
    payload: data,
  }
}

export const setFile = (data) => {
  return {
    type: 'SET_FILE',
    payload: data,
  }
}

export const setExpandedFaq = (id, category, expanded) => {
  return {
    type: 'SET_FAQ_EXPANDED',
    payload: { id, category, expanded },
  }
}

export const setKeywordSearch = (id, keyword) => {
  return {
    type: 'SET_KEYWORD_SEARCH',
    payload: { id, keyword },
  }
}

export const setTabOpen = (id, tabOpen) => {
  return {
    type: 'SET_TAB_OPEN',
    payload: { id, tabOpen },
  }
}
